import { createContext, useContext, useState, useCallback, type ReactNode } from 'react';

const SIDEBAR_WIDTH = 340;

type RightSidebarLayoutContextValue = {
  isSidebarOpen: boolean;
  setSidebarOpen: (open: boolean) => void;
  sidebarWidth: number;
};

const RightSidebarLayoutContext = createContext<RightSidebarLayoutContextValue>({
  isSidebarOpen: true,
  setSidebarOpen: () => {},
  sidebarWidth: SIDEBAR_WIDTH,
});

export function RightSidebarLayoutProvider({ children }: { children: ReactNode }) {
  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const value: RightSidebarLayoutContextValue = {
    isSidebarOpen,
    setSidebarOpen: useCallback((open: boolean) => setSidebarOpen(open), []),
    sidebarWidth: SIDEBAR_WIDTH,
  };
  return <RightSidebarLayoutContext.Provider value={value}>{children}</RightSidebarLayoutContext.Provider>;
}

export function useRightSidebarLayout() {
  return useContext(RightSidebarLayoutContext);
}

export { SIDEBAR_WIDTH };
